import { Inject, Injectable } from '@angular/core';
import { tap } from 'rxjs/operators';
import { GraphRole } from '../models/graph-role';
import { GraphApiService } from './graph-api.service';


@Injectable()
export class Securities {
  /* Represents the Active Directory group for users */
  public static readonly userReadWrite: any = { id: 'a02c0a37-5d96-4a57-a8c1-a1cc095a5fd5',name: 'ResidueDefinitionReadWrite'};
  public static readonly userReadOnly: any = { id: '66e072d9-8b0f-465b-815b-bac10deeee73',name: 'ResidueDefinitionReadOnly'};
  public static readonly adminUser: any = { id: 'f96d4336-7bd0-43a8-b6a6-2ba270ac9ee4',name: 'ResidueDefinitionAdmin'};

  /* Route to redirect users to when they are logged in but don't have permissions to view a page */
  public static unauthRoute = 'unauthorized';

  private graphRoles: GraphRole[];
  public constructor(
  private graphApiService: GraphApiService) { }

  public async setRoles(){
    this.graphRoles = await this.graphApiService.getUserRoles().toPromise();
  }

  public hasPrivilegesForRoles(roles: any[]) {
    const hasPrivileges = roles.map(role => this.hasPrivilegesForRole(role));

    return hasPrivileges.filter(i => i === true).length > 0;
  }

  private hasPrivilegesForRole( role: any): boolean {
    if (this.graphRoles.findIndex(x => x.id === role.id)> 0) {
      return true;
    } else {
      return false;
    }
  }
}
